import React from 'react';
import { Calendar } from 'lucide-react';

const UpcomingEventsPlaceholder = () => {
    return (
        <div className="text-center p-8 bg-slate-50 rounded-lg border-2 border-dashed border-slate-200">
            <div className="flex justify-center items-center mb-4">
                <div className="relative">
                    <Calendar size={40} className="text-slate-300" />
                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full animate-ping"></div>
                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full border-2 border-slate-50"></div>
                </div>
            </div>
            <h4 className="font-bold text-slate-600">Próximamente</h4>
            <p className="text-sm text-slate-400 mt-1">
                Las talleres y cursos sincrónicos que estamos preparando, aparecerán aquí.
            </p>
        </div>
    );
};

export default UpcomingEventsPlaceholder;
